import React, { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link } from "react-scroll";


const Navbar = () => {
  const [navIsOpen, setNavIsOpen] = useState(false);
  const navToggle = () => {
    setNavIsOpen(!navIsOpen);
  };
  const classNameForMdUl = "hidden md:flex";
  const classNameForMdLi =
    "px-4 cursor-pointer font-medium text-grey-500 hover:scale-105 duration-200";
  const classNameForSmUl =
    "flex flex-col justify-center items-center absolute top-0 left-0 w-full h-screen bg-gradient-to-b from-white to-gray-200 text-gray-800";
  const classNameForSmLi = "px-4 cursor-pointer py-6 text-4xl";
  return (
    <div className="flex justify-between items-center w-full   px-2 py-1 fixed">
      <div>
        <a href="/">
          <img class="h-12 mx-2 w-auto" src="/images/logo.png" alt="" />
        </a>
      </div>
      {/* TODO:dark and light */}
      {/* <button className="ml-2 border-2 py-2 px-4 rounded bg-purple-800">
              Dark
            </button> */}
      <ul className={navIsOpen ? classNameForSmUl : classNameForMdUl}>
        <li className={navIsOpen ? classNameForSmLi : classNameForMdLi}>
          <Link to="home" smooth duration={1000} onClick={navToggle}>
            Home
          </Link>
        </li>
        <li className={navIsOpen ? classNameForSmLi : classNameForMdLi}>
          <Link to="portfolio" smooth duration={1000} onClick={navToggle}>
            Portfolio
          </Link>
        </li>
        <li className={navIsOpen ? classNameForSmLi : classNameForMdLi}>
          <Link to="skills" smooth duration={1000} onClick={navToggle}>
            Skills
          </Link>
        </li>
        <li className={navIsOpen ? classNameForSmLi : classNameForMdLi}>
          <Link to="contact" smooth duration={1000} onClick={navToggle}>
            Contact
          </Link>
        </li>
      </ul>

      <div
        className="cursor-pointer pr-4 z-10 text-gray-500 md:hidden"
        onClick={navToggle}
      >
        {navIsOpen ? <FaTimes size={30} /> : <FaBars size={30} />}
      </div>
    </div>
  );
};

export default Navbar;
